import { Icon, type IconType } from "@anna-money/anna-web-ui";
import classNames from "classnames";
import { type FC, type ReactNode } from "react";

import { Text } from "components/Text/Text";
import { getStyle } from "helpers/validators";
import styles from "./Message.module.scss";

type MessageProps = {
  children?: ReactNode;
  type?: MessageType;
  title?: string;
  icon?: IconType;
  className?: string;
  onClick?: () => void;
};

export enum MessageType {
  Info = "info",
  Plain = "plain",
  Warning = "warning",
  Error = "error",
  Flat = "flat",
}

export const Message: FC<MessageProps> = ({ children, type = MessageType.Info, title, icon, className }) => {
  return (
    <div className={classNames(styles.message, getStyle(styles, "type", type), className)}>
      {title ? (
        <Text weight="semibold" className={classNames(styles.title, children ? null : styles.noChildren)}>
          {icon ? <Icon type={icon} color="bwPrimaryDark" size="l" className={styles.icon} /> : null}
          {title}
        </Text>
      ) : null}
      {children ? <Text tag="div">{children}</Text> : null}
    </div>
  );
};
